<template>
    <div class="editDiary-module black">
        <div class="flex flex-y-center flex-start ">
            <img class="icon middle" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/archives.png"
                alt="" />
            <div class="bold font34">{{ name }}-备忘录</div>
        </div>
        <div class="remarks-store   flex flex-around mb-40 font28">
            <div class="title">记录门店</div>
            <div class="info">{{ storeinfo.name }}</div>
        </div>
        <textarea class="descContent font30" v-model="detail.remark" placeholder="请输入内容" adjust-position="false"
            cursor-spacing="100"></textarea>
        <div @click="saveRemark" class="save-btn">提交保存</div>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    name: "addRemarks",
    data() {
        return {
            detail: {

            },
            custId: "",
            name: "",
            phone: "",
            storeinfo: {}
        };
    },
    mounted() {
        this.custId = this.$route.query.custId;
        this.name = this.$route.query.name;
        this.phone = this.$route.query.phone;
        this.onLoad();
    },
    methods: {
        //加载记录门店
        onLoad() {
            request({
                url: `/workEmployee/getStoreInfo`,
                method: "get",
            })
                .then((res) => {
                    this.storeinfo = res.data;
                })
        },

        // 保存
        saveRemark() {
            if (this.detail.remark) {
                request({
                    url: `/custRemark/saveRemark`,
                    method: "post",
                    data: {
                        companyCode: 25001,
                        custId: this.custId,
                        remark: this.detail.remark,
                        storeId: this.storeinfo.id,
                        storeName: this.storeinfo.name,
                    },
                })
                    .then((res) => {
                        if (res.code == 0) {
                            this.$toast({
                                message: "保存成功",
                            });
                            this.$router.push({
                                name: "customerDetail",
                                query: { custId: this.custId, phone: this.phone },
                            });
                        }
                        else {
                            Toast({ position: 'top', message: res.msg })
                        }
                    })
            } else {
                this.$toast({
                    message: "请输入备注",
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.black {
    color: #35434c;
}

.gray {
    color: #a0acb5;
}
/* ------- */
.editDiary-module {
    width: 750px;
    overflow-x: hidden;
    padding: 40px 30px;
    box-shadow: inset 0px 2px 10px -11px rgba(0, 0, 0, 0.8);
}
.icon {
    width: 40px;
    height: 40px;
    margin-right: 27px;
}
.title {
    width: 168px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #35434c;
    line-height: 40px;
}
.info {
    flex: 1;
    text-align: right;
}
.line {
    width: 100%;
    height: 1px;
    background: #d7d7d7;
}
.descContent {
    width: 690px;
    height: 310px;
    background: #f6f6f6;
    border-radius: 16px;
    border: 1px solid #979797;
    padding: 30px;
    color: #a0acb5;
    box-sizing: border-box;
    margin-top: 25px;
}
.save-btn {
    width: 520px;
    height: 90px;
    background: #333f48;
    border-radius: 45px;
    margin: 375px auto 0;
    color: #fff;
    line-height: 90px;
    text-align: center;
    font-size: 30px;
}
:deep(textarea) {
    color: #333f48;
    -webkit-text-fill-color: #333f48; // ios 和 安卓9.0 必须添加此属性，才会生效
}

.remarks-store {
    margin-top: 40px;
}
</style>
